import React from "react";
import SellerDetails from "./SellerDetails";
import BillingDetails from "./BillingDetails";
import ShippingDetails from "./ShippingDetails";
import OrderSummary from "./OrderSummary";
import InvoiceSummary from "./InvoiceSummary";
import ItemList from "./ItemList";
import logo from "../cQube_Logo.png";
import styles from "../styles/invoiceContainer.module.css";

const InvoiceContainer = ({ invoiceData }) => {
  let taxType = "";
  if (invoiceData.placeOfSupply === invoiceData.placeOfDelivery) {
    taxType = "CGST + SGST";
  } else {
    taxType = "IGST";
  }

  return (
    <div className={styles.invoiceContainer}>
      {/* New header row with logo on left and title centered */}
      <div className={styles.headerRow}>
        <img
          src={logo}
          alt="logo"
          className={styles.invoiceContainer__logo}
        />
        <div className={styles.invoiceContainer__header}>
          Tax Invoice/ Bill of Supply/Cash Memo
          <span>(Original for Recipient)</span>
        </div>
      </div>

      {/* Top Row: Billing Address */}
      <div className={styles.topRow}>
        <div className={styles.rightColumn}>
          <div className={styles.billingDetails}>
            <h3>Billing Address:</h3>
            {invoiceData.billingDetails?.name && (
              <div className={styles.addressLine}>
                {invoiceData.billingDetails.name}
              </div>
            )}
            {invoiceData.billingDetails?.address?.addressLine1 && (
              <div className={styles.addressLine}>
                {invoiceData.billingDetails.address.addressLine1}
              </div>
            )}
            {invoiceData.billingDetails?.address?.addressLine2 && (
              <div className={styles.addressLine}>
                {invoiceData.billingDetails.address.addressLine2}
              </div>
            )}
            <div className={styles.addressLine}>
              {invoiceData.billingDetails?.address?.city && (
                <>
                  {invoiceData.billingDetails.address.city}
                  {", "}
                </>
              )}
              {invoiceData.billingDetails?.address?.state && (
                <>
                  {invoiceData.billingDetails.address.state}
                  {", "}
                </>
              )}
              {invoiceData.billingDetails?.address?.pincode}
            </div>
            {invoiceData.billingDetails?.address?.countryAbbr && (
              <div className={styles.addressLine}>
                {invoiceData.billingDetails.address.countryAbbr}
              </div>
            )}
            {invoiceData.billingDetails?.customerGstNo && (
              <div className={styles.addressLine}>
                <strong>GST No:</strong> {invoiceData.billingDetails.customerGstNo}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Rest of the invoice content */}
      <div className={styles.line}>
        <SellerDetails
          name={invoiceData.sellerDetails.name}
          address={invoiceData.sellerDetails.address}
          gstRegistrationNo={invoiceData.sellerDetails.gstRegistrationNo}
        />
      </div>

      <div className={styles.line}>
        <InvoiceSummary
          invoiceNo={invoiceData.invoiceSummary.invoiceNo}
          invoiceDate={invoiceData.invoiceSummary.invoiceDate}
        />
      </div>

      <ItemList
        itemList={invoiceData.itemList}
        taxType={taxType}
        taxRate={invoiceData.taxRate}
      />

      <div className={styles.line}>
        <h3 className={styles.termsTitle}>Terms & Conditions</h3>
        <ul className={styles.termsList}>
          <li>An invoice must accompany products returned for warranty.</li>
          <li>Goods damaged during transit voids warranty.</li>
          <li>30 days limited warranty unless otherwise stated.</li>
          <li>
            30 days limited warranty on OEM processor (an internal part of the
            product) exchange the same items only.
          </li>
          <li>All items carry MFG warranty only. No return or exchange.</li>
        </ul>
      </div>
    </div>
  );
};

export default InvoiceContainer;